// RAPIFAST :: almacenamiento privado de documentos de verificación.
// Requiere la migración 0025_private_verification_storage.sql APLICADA.
// Convención de rutas (debe coincidir con las políticas RLS del bucket):
//   driver-docs/{user_id}/{DOC_TYPE}/{archivo}
//   business-docs/{user_id}/{archivo}
// Nunca usar getPublicUrl ni service_role: el bucket es privado y la
// autorización la hace Storage RLS con la sesión del usuario.
import { supabase } from "./supabase";

export const VERIFICATION_BUCKET = "verification-documents";

// Debe coincidir con el enum driver_doc_type de la migración 0024.
export const DRIVER_DOC_TYPES = [
  "CEDULA",
  "LICENCIA",
  "SOAT",
  "TARJETA_PROPIEDAD",
  "TECNOMECANICA",
];

function safeFilename(name) {
  const base = (name || "documento").split(/[\\/]/).pop();
  return base.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 180);
}

async function requireUser() {
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (!user) throw new Error("Debe iniciar sesión");
  return user;
}

export function buildDocumentPath(kind, userId, docType, filename) {
  if (kind === "driver") {
    if (!DRIVER_DOC_TYPES.includes(docType)) {
      throw new Error("Tipo de documento de conductor inválido");
    }
    return `driver-docs/${userId}/${docType}/${filename}`;
  }
  if (kind === "business") return `business-docs/${userId}/${filename}`;
  throw new Error("Tipo de vinculación inválido");
}

export async function uploadVerificationDocument({ kind, docType, file }) {
  const user = await requireUser();
  const filename = `${crypto.randomUUID()}-${safeFilename(file.name)}`;
  const path = buildDocumentPath(kind, user.id, docType, filename);
  const { data, error } = await supabase.storage
    .from(VERIFICATION_BUCKET)
    .upload(path, file, {
      contentType: file.type || "application/octet-stream",
      cacheControl: "3600",
      upsert: false,
    });
  if (error) throw error;
  return data.path; // guardarlo como storage_path en driver_documents (0024)
}

// URL firmada de corta vida (5 min). Es una URL portadora: no persistirla.
export async function getVerificationDocumentUrl(path) {
  await requireUser();
  const { data, error } = await supabase.storage
    .from(VERIFICATION_BUCKET)
    .createSignedUrl(path, 300, { download: true });
  if (error) throw error;
  return data.signedUrl;
}

export async function openVerificationDocument(path) {
  const url = await getVerificationDocumentUrl(path);
  window.open(url, "_blank", "noopener,noreferrer");
}

export async function deleteVerificationDocument(path) {
  await requireUser();
  const { error } = await supabase.storage
    .from(VERIFICATION_BUCKET)
    .remove([path]);
  if (error) throw error;
}
